import './styles/variables.css';
import './styles/base.css';
import './styles/utilities.css';
import './styles/components.css';
import { mountApp } from './App.js';

mountApp(document.getElementById('app'));